import ToolCard from './ToolCard'

import './PlaceholderToolCard.css'

// TODO: use default props in full
// https://medium.com/@martin_hotell/react-typescript-and-defaultprops-dilemma-ca7f81c661c7
type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
    name: "PLACEHOLD PLACE",
    time: "30-60",
    participants: "2+"
};

class PlaceholderToolCard extends ToolCard {
    public static defaultProps: DefaultProps = defaultProps;

    public constructor(props: any) {
        super(props);
    }
    protected getClassModifiers() : string[] {
        const mods = super.getClassModifiers();
        mods.push("placeholder");
        return mods;
    }

    protected mouseDowned(event: React.MouseEvent) {
        /* do nothin' jon snow = prevent default */
        return;
    };
}

export default PlaceholderToolCard;


// WEBPACK FOOTER //
// ./src/App/Elements/PlaceholderToolCard.tsx